import { render, staticRenderFns } from "./DirectorMessage.vue?vue&type=template&id=ee928776"
import script from "./DirectorMessage.vue?vue&type=script&lang=js"
export * from "./DirectorMessage.vue?vue&type=script&lang=js"
import style0 from "./DirectorMessage.vue?vue&type=style&index=0&id=ee928776&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports